import { Button, Card, Modal } from "react-bootstrap";
import { ProjectFourthStage } from "../../models/project-fourth-stage";
import * as ProjectFourthStageApi from "../../network/project-fourth-stages-api";
import styles from "../../styles/ChangeStageDialog.module.css";

interface FourthStageDialogProps {
    stage: ProjectFourthStage,
    onDismiss: () => void,
}

const FourthStageDialog = ({stage, onDismiss}: FourthStageDialogProps) => {
    const downloadFile = () => {
        ProjectFourthStageApi.fetchProjectFourthStageFile({projectId: stage.projectId});
    }
    
    return(
        <Modal show onHide={onDismiss}>
            <Modal.Header closeButton>
                <Modal.Title>
                    Этап 4
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Card className={`mb-3 ${styles.descriptionField}`}>
                    <Card.Header>
                        Описание
                    </Card.Header>
                    <Card.Body>
                        {stage.text}
                    </Card.Body>
                </Card>
                <Button onClick={downloadFile} className={styles.downloadFileButton}>
                    Скачать закреплённый документ
                </Button>
            </Modal.Body>
        </Modal>
    );
}

export default FourthStageDialog;